import React from 'react';
import { useDispatch } from 'react-redux';

import { HEIGHT_ONE_PERCENT, ITEM_PERCENT_HEIGHT, ITEM_PERCENT_PADDING_TOP } from '../const';
import { ComponentsDispatch } from '../store';
import { setterGantDraggable } from '../store/slices/gantDraggableSlice';
import { setterGantItems } from '../store/slices/gantItemsSlice';
import { DraggableGantSideType, ItemType } from '../types';

interface IGantItemMarker {
    item: ItemType;
    x: number;
    draggingType: DraggableGantSideType;
    onOverMouse: () => void;
}

const GantItemMarker: React.FC<IGantItemMarker> = ({ item, x, draggingType, onOverMouse }) => {
    const dispatch = useDispatch<ComponentsDispatch>();

    const handleResizeMouseDown = () => {
        dispatch(setterGantDraggable({ dragging: draggingType }));
        dispatch(setterGantItems({ isItemEdit: false, currentGantItem: item }));
    };

    const commonProps = {
        onMouseOver: onOverMouse,
        onMouseDown: handleResizeMouseDown,
        cursor: 'ew-resize',
    };

    return (
        <g>
            {/*<circle*/}
            {/*    cx={x}*/}
            {/*    cy={HEIGHT_ONE_PERCENT * MARKER_PADDING_TOP}*/}
            {/*    r="6"*/}
            {/*    fill="white"*/}
            {/*    {...STROKE_PARAM}*/}
            {/*    strokeWidth={1}*/}
            {/*    {...commonProps}*/}
            {/*/>*/}
            <rect
                x={x - 3}
                fill="white"
                y={HEIGHT_ONE_PERCENT * ITEM_PERCENT_PADDING_TOP}
                width={6}
                height={HEIGHT_ONE_PERCENT * ITEM_PERCENT_HEIGHT}
                strokeWidth={1}
                stroke={'#bbb'}
                opacity={1}
                {...commonProps}
            />
            <line
                x1={x}
                y1={HEIGHT_ONE_PERCENT * ITEM_PERCENT_PADDING_TOP * 2 - 3}
                x2={x}
                y2={HEIGHT_ONE_PERCENT * ITEM_PERCENT_PADDING_TOP * 2 + 8}
                stroke={'#ddd'}
                strokeWidth={2}
                {...commonProps}
            />
        </g>
    );
};

// @ts-ignore
export default React.memo(GantItemMarker);
